// removed by extract-text-webpack-plugin
module.exports = {"name":"Gadf56c","address":"Gb3a9b6"};